import produce from 'immer';
import create from 'zustand';

const useStore = create(set => ({
  hasFeaturedWires: false,
  hasQandA: false,
  set: fn => set(produce(fn)),
}));

export default useStore;
